import "./faq.scss";
import Header from "../header/Header";
import Footer from "../footer/footer";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const faqs = [
  { q: "faq_q1", a: "faq_a1" },
  { q: "faq_q2", a: "faq_a2" },
  { q: "faq_q3", a: "faq_a3" },
  { q: "faq_q4", a: "faq_a4" },
  { q: "faq_q5", a: "faq_a5" },
  { q: "faq_q6", a: "faq_a6" },
  { q: "faq_q7", a: "faq_a7" },
  { q: "faq_q8", a: "faq_a8" },
];

const FAQItem = ({ q, a }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`faq-item ${open ? "open" : ""}`}
      onClick={() => setOpen(!open)}
    >
      <div className="faq-question">
        <h3>{t(q)}</h3>
        <span className="faq-icon">{open ? "−" : "+"}</span>
      </div>
      {open && <p className="faq-answer">{t(a)}</p>}
    </div>
  );
};

const FAQ = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <main className="faq-page">
        <div className="faq-hero">
          <h1 className="faq-title">{t("faq_title")}</h1>
          <p className="faq-subtitle">{t("faq_subtitle")}</p>
        </div>
        <div className="faq-list">
          {faqs.map((item, i) => (
            <FAQItem key={i} q={item.q} a={item.a} />
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default FAQ;
